exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg{cursor:pointer;background-color:#fff;vertical-align:baseline;width:17px;height:17px}.svg-large{width:20px;height:20px}.cls-1{fill:#ccc}.cls-1,.cls-2{fill-rule:evenodd}.cls-2{fill:#0066b3}.cls-3{fill:#f60}.cls-4{fill:#c00}.cls-5{fill:#fff;fill-rule:evenodd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"11","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/vrnet-icons.vue
// module id = 0RD7
// module chunks = 0